import(/* webpackMode: "eager" */ "/vercel/path0/components/ads/AdSlot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppPromptTrigger"] */ "/vercel/path0/components/layout/AppPromptTrigger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CardShareToggle"] */ "/vercel/path0/components/share/CardShareToggle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoadMoreClient"] */ "/vercel/path0/components/stickers/LoadMoreClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StickerCardDesktopMeta","StickerCardDesktopBlurb","StickerCardDesktopTags"] */ "/vercel/path0/components/stickers/StickerCardDesktopExtras.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TagChipLink"] */ "/vercel/path0/components/stickers/TagChipLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/.pnpm/lucide-react@1.14.0_react@19.2.6/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.3.8_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@playwright+test@1.59.1_@types+node@2_ydxhzva44pdhw6z7bqbib3xgui/node_modules/next/dist/client/image-component.js");
